import { Bell } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useVorgaengeAlerting } from '@/adapter/opm-cockpit-backend/useVorgaengeAlerting';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { VorgangFilters } from '@/types/filters';

export interface VorgaengeAlertPresetLocationState {
  presetFilters?: Partial<VorgangFilters>;
}

const formatAlertCount = (count: number): string =>
  count.toLocaleString('de-DE');

export const AlertBellNotification: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useVorgaengeAlerting();

  const count = data?.count ?? 0;
  const hasAlerts = count > 0;
  const countLabel = isLoading ? '…' : formatAlertCount(count);

  const handleClick = () => {
    navigate('/vorgaenge', {
      state: {
        presetFilters: {
          status: 'WARTEND,LAUFEND',
          stale24h: true,
        },
      } satisfies VorgaengeAlertPresetLocationState,
    });
  };

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handleClick}
      aria-label={`Vorgang-Alerting (${isLoading ? '…' : count})`}
      className="h-auto overflow-visible px-1.5 py-1.5 hover:bg-accent/60"
    >
      <span className="inline-grid grid-cols-[auto_auto] items-start gap-0">
        <Bell
          className={cn(
            'col-start-1 row-start-1 size-8 shrink-0',
            hasAlerts
              ? 'text-destructive animate-alert-bell'
              : 'text-green-600',
          )}
        />
        {hasAlerts && (
          <span className="col-start-2 row-start-1 z-10 -ml-3.5 -mt-1 flex h-4 min-w-4 items-center rounded-full bg-destructive px-1.5 text-[10px] font-bold leading-none whitespace-nowrap text-white tabular-nums">
            {countLabel}
          </span>
        )}
      </span>
    </Button>
  );
};
